import { render, staticRenderFns } from "./countdownBanner.vue?vue&type=template&id=b0764ace&scoped=true"
import script from "./countdownBanner.vue?vue&type=script&lang=js"
export * from "./countdownBanner.vue?vue&type=script&lang=js"
import style0 from "./countdownBanner.vue?vue&type=style&index=0&id=b0764ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0764ace",
  null
  
)

export default component.exports